import { TimelineMax, TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import EcoCreditsDayPc from '@/components/EcoCreditsDay';
import EcoCreditsDayH5 from '@/componentsH5/EcoCreditsDay';
import { useGlobal } from '@/utils/useGlobal';
import { redirectTo404 } from '@/utils';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useLang } from '@/i18n';
import { fixedLoginBtn, fixedLoginBtnH5 } from '@/data/ecocreditsday/index';
import gtm from '@/utils/gtm';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/ecocredits-day';

export default function EcoCreditsDay({ SEO, lang }: any) {
    const { isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecocreditsday');

    const fixedLoginBtnData = isMobile ? fixedLoginBtnH5[locale as keyof typeof locale] : fixedLoginBtn[locale as keyof typeof locale];

    const EcoCreditsDay = isMobile ? EcoCreditsDayH5 : EcoCreditsDayPc;

    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.controllerDay = new ScrollMagic.Controller();
    }

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: '.eco-credits__box',
            offset: window.innerHeight / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 450,
        });
        const tween = TweenMax.to('.eco-credits__box .ecocredits-fixed__btn', 2, { opacity: 1 });
        scene.setTween(tween);
        controllerDay.addScene(scene);

        return () => {
            scene && scene.destroy();
            // 先移除scene 再移除controller
            // scene 在子模块内移除
            // 因卸载阶段父组件先触发，所以需setTimeout滞后
            setTimeout(() => {
                (window?.controllerDay as any)?.destroy(true);
            }, 30);
        };
    }, []);

    const handleLoginClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: t('fixedLogin.text'),
        });
        window.open(fixedLoginBtnData?.btnLink, '_blank');
    };
    const renderLoginFixedButton = () => {
        return (
            <div className={`${isMobile ? 'loginfixedbuttonmobile' : 'loginfixedbutton'} ecocredits-fixed__btn`} onClick={handleLoginClick}>
                <div className="login-box">
                    <div className="svg-item" style={{ background: `url("${fixedLoginBtnData?.svgUrl}") no-repeat` }}></div>
                    <span className="login-button-text">{t('fixedLogin.text')}</span>
                </div>
            </div>
        );
    };

    return (
        <div className={css.ecoCreditsDayBox}>
            <SEO title={lang?.seoTitle} description={lang?.seoDesc} hideTitleTemplate />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <div className="eco-credits__box">
                <PageLayout theme="black" isNoFixed>
                    <EcoCreditsDay />
                    {['us', 'ca'].includes(locale as keyof typeof locale) && renderLoginFixedButton()}
                </PageLayout>
            </div>
        </div>
    );
}

export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = ['jp', 'za', 'kr', 'au', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca'];
    const redirectLocale = ['au', 'kr', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca'];
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    if (redirectLocale.includes(locale)) {
        return {
            redirect: {
                destination: `/${locale}/members-day`,
                permanent: true,
            },
        };
    }
    return {
        props: {},
    };
}
